import { useEffect, useState } from 'react'
import { Icon, Markdown } from '@carrent/ui'
import { kbApi } from '@carrent/api'

const resolveImage = (href) => {
  const m = String(href || '').match(/^attachment:(\d+)$/)
  if (m) return kbApi.attachmentUrl(m[1])
  return /^(https?:|\/)/i.test(href) ? href : null
}

/**
 * Подсказка «как это делать» прямо на рабочем экране.
 *
 * Водитель, размечающий повреждения, не должен уходить в отдельный
 * раздел за регламентом фотофиксации и терять начатую приёмку.
 * Инструкция открывается поверх экрана и закрывается на месте.
 *
 * Статья ищется по своему заголовку, а не по жёстко прошитому
 * идентификатору: id живёт в базе конкретной установки, и ссылка
 * на него сломалась бы при переносе или пересоздании статьи.
 * Не нашлась — кнопки просто нет, экран работает как раньше.
 */
export function ContextHelp({ query, label = 'Как это работает' }) {
  const [hit, setHit] = useState(null)
  const [open, setOpen] = useState(false)
  const [page, setPage] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let cancelled = false
    kbApi.search(query)
      .then((r) => {
        if (cancelled) return
        setHit((r.data?.data || [])[0] || null)
      })
      .catch(() => {
        // Справка — вспомогательная вещь: её отсутствие не должно
        // мешать основной работе экрана.
        if (!cancelled) setHit(null)
      })
    return () => { cancelled = true }
  }, [query])

  useEffect(() => {
    if (!open || !hit || page) return
    setLoading(true)
    kbApi.page(hit.page_id)
      .then((r) => setPage(r.data?.data || null))
      .catch(() => setPage(null))
      .finally(() => setLoading(false))
  }, [open, hit, page])

  if (!hit) return null

  return (
    <>
      <button type="button" className="ctx-help__trigger" onClick={() => setOpen(true)}>
        <Icon name="file" size={15} aria-hidden="true" />
        {label}
      </button>

      {open && (
        <div className="sheet-overlay" role="dialog" aria-modal="true"
          aria-label={hit.title}
          onClick={(e) => e.target === e.currentTarget && setOpen(false)}>
          <div className="sheet ctx-help__sheet">
            <header className="sheet__header">
              <span className="sheet__title">{hit.title}</span>
              <button type="button" className="ctx-help__close"
                onClick={() => setOpen(false)} aria-label="Закрыть">
                <Icon name="close" size={20} />
              </button>
            </header>

            <div className="ctx-help__body">
              {loading && <div className="kb-m__loading"><div className="spinner" /></div>}
              {!loading && page && (
                <Markdown text={page.body_md} resolveImage={resolveImage}
                  className="kb-m__body" />
              )}
              {!loading && !page && (
                <p className="kb-m__state-hint">
                  Инструкция сейчас недоступна — возможно, пропала связь.
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
